import get from 'lodash/get'

export const getBtTokenValueForFastPass = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled, value }) => name === 'fastPass')
  if (!enabledFeature) {

    return false

  }

  return enabledFeature.value

}
